import { render, staticRenderFns } from "./AscRemovalsTimelineTemplate.vue?vue&type=template&id=03dc9972&"
import script from "./AscRemovalsTimelineTemplate.vue?vue&type=script&lang=js&"
export * from "./AscRemovalsTimelineTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports